module.exports = __webpack_public_path__ + "media/old_images/image-promo-user-0d0a535c.jpg";